import { JSX } from 'react';

export interface DesktopContainerProps {
    children: JSX.Element;
    noTopPadding?: boolean;
    fullWidth?: boolean;
    customTopPadding?: string;
    customBgColor?: string;
}

export const DesktopContainer = ({
    children,
    noTopPadding = false,
    fullWidth = false,
    customTopPadding,
    customBgColor,
}: DesktopContainerProps) => {
    const getTopPadding = () => {
        if (customTopPadding) return customTopPadding;
        if (noTopPadding) return '';
        return 'pt-10';
    };

    const getBgColor = () => {
        if (customBgColor) return customBgColor;
        return 'bg-secondary-dark light:bg-gz-surface-light dark:bg-gz-blue-900';
    };

    return (
        <div className={`min-h-screen flex flex-col w-full light:text-foreground dark:text-foreground ${getBgColor()}`}>
            <div className={`${getTopPadding()} pb-20 ${getBgColor()} h-full`}>
                <div
                    className={
                        fullWidth
                            ? 'flex w-full max-w-none gap-4 xl:gap-6'
                            : 'flex w-full max-w-none gap-4 xl:gap-6 lg:container lg:mx-auto'
                    }
                >
                    {children}
                </div>
            </div>
        </div>
    );
};
